module.exports = __webpack_public_path__ + "static/img/notice-de.0469502b.jpg";